import { asyncAction } from '@jarvis.oddle/core/tools/redux/action'
import {
  loadStoreItemAvailabilityApi
} from 'api/fesc/client'
import * as C from './constants'

export const fetchStoreItemAvailabilityAction = ({ req } = {}) => asyncAction({
  api: loadStoreItemAvailabilityApi,
  requestAction: C.GET_STORE_ITEM_AVAILABILITY_REQUEST,
  successAction: C.GET_STORE_ITEM_AVAILABILITY_SUCCESS,
  failureAction: C.GET_STORE_ITEM_AVAILABILITY_FAILURE
})((getState) => {
  const metaState = getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  return { menuId, req }
})
